// extracted by mini-css-extract-plugin
export var btn = "K_mB y_tH y_tq d_bz d_bP d_bD d_dw";
export var full = "K_vV d_w d_H";
export var hoverStyle = "K_mF";
export var zoom = "K_mG";